import { render } from "./SinglePageList.vue?vue&type=template&id=dc142ad4&scoped=true"
import script from "./SinglePageList.vue?vue&type=script&lang=js"
export * from "./SinglePageList.vue?vue&type=script&lang=js"

import "./SinglePageList.vue?vue&type=style&index=0&id=dc142ad4&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc142ad4"]])

export default __exports__